import React, { ReactElement } from 'react';
import { Loader } from 'idsk-react-components';
import './vseobecnyObalMaterialu.scss';
import Uuid from '../../../../model/Uuid';
import { useClient } from '../../../../context/ClientStatusContext';
import {
  fetchObalMaterialuNrSrInitData,
} from '../../../../client/pracovnyKrok/sprievodnyDokument/obalMaterialuInitDataClient';
import useObalMaterialNrSrInitData
  from '../../../../page/SprievodnyDokument/ObalMaterialu/hook/useObalMaterialNrSrInitData';
import ObalMaterialuNrSr from './ObalMaterialuNrSr';
import { createObalMaterialuNrSrClient } from '../../../../client/external/evidencnaaplikacia/obalMaterialuNrSrClient';

interface ObalMaterialuProps {
  materialUuid: Uuid,
  type: string,
  year: number,
  index: number,
  stadiumUuid: Uuid,
}

const ObalMaterialuNrSrWrapper = ({
  materialUuid, type, year, index, stadiumUuid,
}: ObalMaterialuProps): ReactElement => {
  const {
    obalInitData,
    initDataStatus,
  } = useObalMaterialNrSrInitData(type, year, index);

  const {
    wrapClient: fillSystemDataClient,
    status: fillSystemDataStatus,
    data: fillSystemData,
  } = useClient(fetchObalMaterialuNrSrInitData);

  const {
    wrapClient: createObalMaterialuNrSr,
    status: submitStatus,
  } = useClient(createObalMaterialuNrSrClient);

  return (
    <Loader loading={initDataStatus.loading || fillSystemDataStatus.loading}>
      {obalInitData && (
        <ObalMaterialuNrSr
          initFormData={obalInitData}
          onSubmitForm={(formData) => createObalMaterialuNrSr(materialUuid, formData, stadiumUuid)}
          fillSystemDataClient={fillSystemDataClient}
          fillSystemData={fillSystemData}
          fillSystemDataStatus={fillSystemDataStatus}
          submitStatus={submitStatus}
        />
      )}
    </Loader>
  );
};

export default ObalMaterialuNrSrWrapper;
